import { Sprinkles } from '@/theme/sprinkles.css';
import Box, { BoxProps } from '../ui/Box';
import Container, { ContainerProps } from '../ui/Container';
import Grid, { GridColProps, GridProps } from '../ui/Grid';

export type PageHeaderRootProps = BoxProps<
  'header',
  {
    variant?: 'home' | 'overview' | 'index' | 'article' | 'standard' | 'event' | 'educationalEvent';
    maxWidth?: ContainerProps['maxWidth'];
    show?: {
      date?: boolean;
      author?: boolean;
    };
    afterGrid?: React.ReactNode;
    afterCol?: React.ReactNode;
    beforeCol?: React.ReactNode;
    afterContainer?: React.ReactNode;
    beforeContainer?: React.ReactNode;
    GridProps?: GridProps;
    GridColProps?: GridColProps;
    ContainerProps?: ContainerProps;
  }
>;

const PageHeaderRoot = ({
  children,
  variant = 'standard',
  maxWidth,
  afterGrid,
  afterCol,
  beforeCol,
  afterContainer,
  beforeContainer,
  cx: customCx,
  GridProps: customGridProps,
  GridColProps,
  ContainerProps,
  ...props
}: PageHeaderRootProps) => {
  const cx: Sprinkles = {
    position: 'relative',
    overflow: 'hidden',
    ...customCx,
  };

  const GridProps: GridProps = {
    cx: {
      rowGap: 'xl',
      pY: '5xl',
    },
    ...((variant === 'overview' || variant === 'standard' || variant === 'home') && {
      cx: {
        pY: 'none',
      },
    }),
    ...customGridProps,
  };

  return (
    <Box as="header" {...props} cx={cx}>
      {beforeContainer}
      <Container maxWidth={maxWidth} {...ContainerProps}>
        <Grid {...GridProps}>
          {beforeCol}
          <Grid.Col {...GridColProps}>{children}</Grid.Col>
          {afterCol}
        </Grid>
        {afterGrid}
      </Container>
      {afterContainer}
    </Box>
  );
};

export default PageHeaderRoot;
